<template lang="pug">
  #tooltip
    v-container.pa-0(grid-list-xs)
      v-layout.ma-0.pa-0(row, wrap)
        v-card.tooltip.ma-0.pa-0(flat)
          v-layout.ma-0.pa-0(fluid, row, wrap)
            v-flex(xs3).pa-0
              v-card-text.data.folio.pb-0.pt-1
                | #0008
              v-card-text.data.pt-0.pb-0 21 feb 2018
              v-card-actions.d-flex.pb-1.pt-2
                v-btn.view(flat justify-center) VER POSTAL
            v-flex(xs9).pa-0
              v-card-title.pa-1(primary-title)
                div.title
                  h3.headline.mb-0 Campeche /&nbsp;
                    span.mun Campeche
                  span.type  Intimidación y hostigamiento
              v-card-text.description.pa-1 Rosa Santana, corresponsal del Semanario Proceso en Campeche fue víctima de intimidación y hostigamiento por presuntos elementos policiales de SSP Estatal de Campeche en la capital del estado el 11 de marzo de 2018. Rosa Santana, corresponsal del Semanario Proceso en Campeche fue víctima de intimidación y hostigamiento por presuntos elementos policiales de SSP Estatal de Campeche en la capital del estado el 11 de marzo de 2018.
      //v-layout(row, wrap)
        v-flex(xs3)
          v-card(flat)
            .folio.pt-2.px-4
              p.text-sm-left.mb-0 #0008
            .date.px-4
              p.text-sm-left.mb-0 21 feb 2018
            .postcard.py-1.px-4
              p.text-sm-center.mb-0 VER POSTAL PARA REDES
            .map.py-1.px-4
              p.text-sm-center.mb-0 VER EN MAPA
        v-flex(xs9)
          v-card(flat)
            .place.pa-1
              p.text-sm-left.mb-0
                span Campeche /&nbsp;
                | Campeche
            .type.pa-1
              p.text-sm-left.mb-0 Intimidación y hostigamiento
            .details.pa-1
              p.text-sm-left.mb-0 Rosa Santana, corresponsal del Semanario Proceso en Campeche fue víctima de intimidación y hostigamiento por presuntos elementos policiales de SSP Estatal de Campeche en la capital del estado el 11 de marzo de 2018.
</template>

<script>
export default {
  name: "Tooltip"
  //props: {}
};
</script>

<style scoped lang="scss">
@import "../app.scss";

#tooltip {
  width: 625px;
  height: 158px;
  border: solid 4px #c1d542;
  background-color: #f8f8f8;
  font-family: "Rajdhani", sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  .tooltip {
    background-color: $light-background !important;
    margin: 0.6rem;
    .data {
      color: $light-text;
      font-weight: 600;
      font-size: 1.3rem;
      &.folio {
        font-size: 1.5rem !important;
      }
    }
    .view {
      border: 1.5px solid $medium-text;
      border-radius: 5px;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2) !important;
      color: $medium-text !important;
      max-width: 80%;
      font-size: 1rem;
      font-weight: 700;
      padding-top: 0;
    }
    .title {
      color: $dark-title;
      h3 {
        font-family: "Barlow Semi Condensed", sans-serif !important;
        font-weight: 600;
        .mun {
          font-weight: 500;
        }
      }
      .type {
        font-size: 16px !important;
        font-weight: 500 !important;
      }
    }
    .description {
      color: $dark-text;
      padding-top: 0;
      font-size: 1.1rem;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
  }
  /*.folio, .date {
      p {
        color: rgba(139, 139, 139, 0.87);
        font-size: 19px;
        font-weight: 600;
      }
    }
    .postcard, .map {
      p {
        color: #747474;
        border: solid 1px #747474;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .place {
      p {
        color: #212034;
        font-family: 'Barlow', sans-serif;
        font-size: 21px;
        font-weight: 400;
        span {
          font-weight: 600;
        }
      }
    }
    .type {
      p {
        color: #212034;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .details {
      p {
        color: #4a4a4a;
        font-size: 15px;
        font-weight: 500;
      }
    }*/
}
</style>
